import "./EndGameLeaderboard.css";
import { useAppSelector } from "./store";
import star from "./assets/star.svg";

function EndGameLeaderboard() {
  const players = useAppSelector((state) => {
    return state.endGameLeaderboard.players;
  });
  const game = useAppSelector((state) => {
    return state.game;
  });
  const historicScores = useAppSelector((state) => {
    return state.historicLeaderboard;
  });

  function isHistoric(playerID: string): boolean {
    if (
      historicScores.highScores.find((score) => {
        return score.gameID === game.id && score.playerID === playerID;
      })
    ) {
      return true;
    }
    if (
      historicScores.lowScores.find((score) => {
        return score.gameID === game.id && score.playerID === playerID;
      })
    ) {
      return true;
    }
    return false;
  }

  const rows = players.map((player) => {
    const onLeaderboard = isHistoric(player.id) ? (
      <img className="onLeaderboardImg" src={star} />
    ) : (
      <span></span>
    );
    return (
      <tr key={player.id} className="end">
        <td className="end">{player.name}</td>
        <td className="end">
          {player.score} {onLeaderboard}
        </td>
      </tr>
    );
  });

  return (
    <div>
      <table className="end centerContainer">
        <tbody className="end">{rows}</tbody>
      </table>
    </div>
  );
}

export default EndGameLeaderboard;
